import { BaseEntity, ObjType } from "./BaseEntity";

/** 種別 */
export const MESSAGE_TYPE: ObjType = {
  "0": "メッセージ",
  "1": "QR",
};

// 時刻
export const DATE_HOUR: ObjType = {
  "0": "0",
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "6": "6",
  "7": "7",
  "8": "8",
  "9": "9",
  "10": "10",
  "11": "11",
  "12": "12",
  "13": "13",
  "14": "14",
  "15": "15",
  "16": "16",
  "17": "17",
  "18": "18",
  "19": "19",
  "20": "20",
  "21": "21",
  "22": "22",
  "23": "23",
};
export const DATE_MINUTE: ObjType = {
  "0": "0",
  "10": "10",
  "20": "20",
  "30": "30",
  "40": "40",
  "50": "50",
};

/**
 * メッセージ(mdm_message)
 */
export class MdmMessage extends BaseEntity {
  /** メッセージID */
  public id: string = "";
  /** 名前 */
  public messageName: string = "";
  /** 送信日時 */
  public sendDate: Date = new Date();
  /** QRテキストタイトル */
  public qrtextTitle: string = "";
  /** 本文 */
  public messageBody: string = "";
  /** 種別 */
  public messageType: string = "";
  /** 機種 */
  public targetModel: string = "";
  /** 送信完了フラグ */
  public sendedFlag: string = "";
  /** テナントID */
  public tenantId: string = "";
}
